import { useMemo } from 'react';
import { keyBy } from 'lodash-es';
import { UseQueryResult } from '@tanstack/react-query';
import { useHtLuSSchedulerFiltersStore, useLiSSchedulerFiltersStore } from '@lp/core/store/scheduler';
import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { getSRegionToResourceMap } from '@lp/features/Scheduler/SchedulerSurgeons/utils';
import { SRegion, SResourcesWithShifts } from '@/api/apis/resources/schedule';

export const createSSchedulerServicesHook =
  (useSScheduleRegionsQuery: () => UseQueryResult<SRegion[]>) =>
  (shiftsData?: SResourcesWithShifts, regionAssignedSurgeonsMap: Record<string, string[]> = {}) => {
    const { data: regionList } = useSScheduleRegionsQuery();

    const regionsDictionary = useMemo(() => {
      return keyBy(regionList ?? [], 'id');
    }, [regionList]);

    const regionToResourceMap = useMemo(() => {
      if (!shiftsData) return null;
      return getSRegionToResourceMap(shiftsData, regionAssignedSurgeonsMap);
    }, [shiftsData, regionAssignedSurgeonsMap]);

    return {
      regionList,
      regionsDictionary,
      regionToResourceMap,
    };
  };

export const getUseSSchedulerFiltersStore = (organGroup: SOrganGroup) => {
  const storeMap = {
    [SOrganGroup.HeartAndLungs]: useHtLuSSchedulerFiltersStore,
    [SOrganGroup.Liver]: useLiSSchedulerFiltersStore,
  };

  return storeMap[organGroup];
};
